exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__header[data-v-933dc0a2]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;align-items:center}.help[data-v-933dc0a2]{margin-left:10px;width:30px;height:30px}", ""]);

// exports
